export default __webpack_public_path__ + "static/media/information.88b620e3.svg";